<template>
  <div id="haus" class="section">
    <div class="container">
      <div class="md-layout">
        <div
          class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
        >
          <h2 class="title text-center">Ferienhaus deBontje</h2>
          <h5 class="description">
            Das Ferienhaus deBontje ist ein freistehendes Komfort-Friesenhaus.
            2015 wurde das Ferienhaus komplett saniert und bietet auf 95 m2
            Wohnfläche ausreichend Platz für bis zu 6 Personen und ein
            Kleinkind. Am Ende einer Sackgasse und in direkter Nähe zum Deich
            ist es angenehm ruhig und dennoch zentral gelegen. Den historische
            Hafen bzw. den Dorfkern sowie Einkaufsmöglichkeiten, das Ärztehaus,
            einen Abenteuerspielplatz und die Badestelle erreichen Sie in nur
            wenigen Gehminuten. Hier können Sie die Lage unseres Ferienhauses
            auf der Karte sehen. Vor dem Haus gibt es 2 PKW Stellplätze. Bitte
            haben Sie Verständnis dafür, dass Haustiere in unserem Ferienhaus
            nicht gestattet sind. Das deBontje ist ein Nichtraucherhaus.
          </h5>
        </div>
      </div>
      <div class="features text-center">
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-info">
                <md-icon>map</md-icon>
              </div>
              <h4 class="info-title">Nah am Ort</h4>
              <p>
                Im Mittelpunkt des Erdgeschosses steht der großzügige Wohn- und
                Essbereich mit der modern ausgestattete Küchenzeile. Außerdem
                befinden sich dort das große Badezimmer mit Infrarotwärmekabine,
                ein Hauswirtschaftsraum mit Waschmaschine und ein Doppelzimmer.
              </p>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-success">
                <md-icon>face</md-icon>
              </div>
              <h4 class="info-title">Kinderfreundlich</h4>
              <p>
                Das deBontje ist außerdem ganz auf die Bedürfnisse unserer
                kleinen Gäste eingestellt. Neben einer kindergerechten
                Einrichtung finden Sie im deBontje viele Gegenstände, die eine
                altersgerechte Beschäftigung Ihrer Kinder ermöglichen.
              </p>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-danger">
                <md-icon>settings</md-icon>
              </div>
              <h4 class="info-title">Moderne Ausstattung</h4>
              <p>
                Das deBontje ist außerdem ganz auf die Bedürfnisse unserer
                kleinen Gäste eingestellt. Neben einer kindergerechten
                Einrichtung finden Sie im deBontje viele Gegenstände, die eine
                altersgerechte Beschäftigung Ihrer Kinder ermöglichen.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="md-layout-item md-size-100 md-small-size-100">
      <nav-tabs-card no-label>
        <template slot="content">
          <md-tabs class="md-success" md-alignment="left">
            <md-tab
              id="tab-erdgeschoss"
              md-label="Erdgeschoss"
              md-icon="living"
            >
              <div class="md-layout">
                <div class="md-layout-item md-size-60 md-small-size-100">
                  <p>
                    Im Mittelpunkt des Erdgeschosses steht der großzügige Wohn-
                    und Essbereich mit der modern ausgestattete Küchenzeile.
                    Außerdem befinden sich dort das große Badezimmer mit
                    Infrarotwärmekabine, ein Hauswirtschaftsraum mit
                    Waschmaschine und ein Doppelzimmer. Die gemütlich Sofaecke
                    mit TV und Kamin lädt dazu ein, sich an einem verregneten
                    Tag mit einem Spiel oder einem guten Buch aus der
                    Hausbibliothek die Zeit angenehm zu gestalten.
                  </p>
                </div>
                <div
                  class="md-layout-item md-size-40 md-small-size-100 text-left"
                >
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    barrierefrei
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    großzügiger Wohn- und Essbereich mit moderner Küchenzeile
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> 1
                    Schlafzimmer (Doppelzimmer)
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> großes,
                    behindertenfreundliches Badezimmer mit Infrarotwäremekabine
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Hauswirtschaftsraum mit Waschmaschine, Bügeleisen und
                    Bügelbrett, Ausgusswaschbecken & Wäscheständer
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> Kamin
                  </p>
                </div>
              </div>
            </md-tab>

            <md-tab
              id="tab-obergeschoss"
              md-label="Obergeschoss"
              md-icon="stairs"
            >
              <div class="md-layout">
                <div class="md-layout-item md-size-60 md-small-size-100">
                  <p>
                    Über die Treppe im Wohn- und Essbereich gelangen Sie in das
                    obere Stockwerk. Neben einem weiteren Badezimmer und 3
                    Schlafzimmern finden Sie hier auf der Empore einen
                    gemütlichen Lesesessel.
                  </p>
                </div>
                <div
                  class="md-layout-item md-size-40 md-small-size-100 text-left"
                >
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> 3
                    Schlafzimmer (1 Doppel- und 2 Einzelzimmer)
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>Badezimmer
                    mit Tageslicht
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i
                    >gemütlicher Lesesessel zum Schmökern auf der Empore
                  </p>
                </div>
              </div>
            </md-tab>

            <md-tab id="tab-garten" md-label="Garten" md-icon="yard">
              <div class="md-layout">
                <div class="md-layout-item md-size-60 md-small-size-100">
                  <p>
                    Zu unserem Ferienhaus gehört ein ca. 300 m2 großer
                    eingezäunter und blickgeschützter Garten. Die große
                    Liegewiese bietet viel Platz zum Spielen mit den Kindern
                    oder für entspannte Stunden in der Sonne. Sonnenliegen sind
                    vor Ort. Die ca. 30m2 große Sonnenterrasse in Südwestlage
                    hat einen Glaswindfang und eine Markise, damit Sie auf alle
                    Witterungsbedingungen optimal vorbereitet sind. Außerdem
                    gehören ein Strandkorb, Gartenmöbel und ein Holzkohlegrill
                    zur Austattung.
                  </p>
                </div>
                <div
                  class="md-layout-item md-size-40 md-small-size-100 text-left"
                >
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Fahrradschuppen
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Holzkohlegrill
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Gartenmöbel
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> Liegen
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Strandkorb
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> Markise
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> verglaste
                    Windschutzwände auf der Terrasse
                  </p>
                </div>
              </div>
            </md-tab>

            <md-tab id="tab-info" md-label="Weitere Infos" md-icon="info">
              <div class="md-layout">
                <div class="md-layout-item md-size-60 md-small-size-100">
                  <p>
                    Zu unserem Ferienhaus gehört ein ca. 300 m2 großer
                    eingezäunter und blickgeschützter Garten. Die große
                    Liegewiese bietet viel Platz zum Spielen mit den Kindern
                    oder für entspannte Stunden in der Sonne. Sonnenliegen sind
                    vor Ort. Die ca. 30m2 große Sonnenterrasse in Südwestlage
                    hat einen Glaswindfang und eine Markise, damit Sie auf alle
                    Witterungsbedingungen optimal vorbereitet sind. Außerdem
                    gehören ein Strandkorb, Gartenmöbel und ein Holzkohlegrill
                    zur Austattung.
                  </p>
                </div>
                <div
                  class="md-layout-item md-size-40 md-small-size-100 text-left"
                >
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> W-Lan
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> Sat-TV
                    mit Flachbildschirm 40 Zoll, Stereoanlage (CD-Player),
                    5.1Surround-Anlage
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> Blue-ray
                    Player
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Playstation 2 incl. Kontroller & Spielen
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> Rollläden
                    (z.T. elektrisch) & Fliegengitter
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Hausbibliothek & Spiele für jedes Alter
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Treppensicherungsrollo im Obergeschoss
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Kinderhochstuhl für Baby / Kleinkind (Tripp-Trapp)
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Kinderspielsachen (Duplo-Steine, Holzbausteine, Puzzle,
                    Kinderbücher, Spiele)
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Toilettenaufsatz, Wickelauflage
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Nachtlicht im Kinderzimmer, Bewegungslicht im Flur OG
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i>
                    Babywarmhalteteller
                  </p>
                  <p class="text-muted">
                    <i class="material-icons">check_circle_outline</i> diverse
                    Kinder-DVDs
                  </p>
                </div>
              </div>
            </md-tab>
          </md-tabs>
        </template>
      </nav-tabs-card>
    </div>
  </div>
</template>

<script>
import { NavTabsCard } from "@/components";

export default {
  components: {
    NavTabsCard
  }
};
</script>
